module.exports = __webpack_public_path__ + "img/logo.df4fadc5.png";